module.exports = __webpack_public_path__ + "img/2F2FAA_1E1E87_10104E_1C1C70-256px.97e64019.png";